






















































































































import { Vue, Component } from 'vue-property-decorator';
import { Toast, Swipe, SwipeItem, Popup } from 'vant';
import { getRules, getNewsList, getShowList } from '../api';
import { getChannelList } from '../api/util';
import NewsItem from '../components/NewsItem.vue';
import Swiper from 'swiper';
// import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.min.css';

Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Toast);
Vue.use(Popup);

@Component({
  components: {
    NewsItem,
    // Swiper,
    // SwiperSlide,
  },
})
export default class Home extends Vue {
  imgsList: any[] = [];
  newsList: any[] = [];
  newsList1: any[] = [];
  page: number = 1;
  // classId: number = 3252;
  // classId1: number = 3249;
  obj: any = {};
  tabs: any[] = [];
  currentInx: any = '0';
  isshowimg: boolean = false;
  showimginx: number = -1;

  async mounted() {
    this.tabs = getChannelList();
    const res = await getRules();
    this.obj = res.data;
    getNewsList(this.page, '发现最美', this.tabs[0])
      .then((res: any) => {
        if (res.statusCode !== 200) {
          Toast(res.message);
          return;
        }
        const list =
          res.data &&
          res.data.data instanceof Array &&
          res.data.data.length > 0 &&
          res.data.data[0].list instanceof Array
            ? res.data.data[0].list
            : [];
        // this.newsList = [...this.newsList, ...list];
        this.newsList = list.splice(0, 2);
      })
      .catch(() => {
        Toast('网络错误');
      });
    getNewsList(this.page, '最美赛道', this.tabs[1])
      .then((res: any) => {
        if (res.statusCode !== 200) {
          Toast(res.message);
          return;
        }
        const list =
          res.data &&
          res.data.data instanceof Array &&
          res.data.data.length > 0 &&
          res.data.data[0].list instanceof Array
            ? res.data.data[0].list
            : [];
        // this.newsList1 = [...this.newsList1, ...list];
        this.newsList1 = list.splice(0, 3);
      })
      .catch(() => {
        Toast('网络错误');
      });
    getShowList().then((res: any) => {
      if (res.code === 200) {
        if (!res.data) {
          Toast(res.msg);
          return;
        }
        this.currentInx = '1';
        let data = JSON.parse(res.data);
        if (data.length <= 2) {
          this.currentInx = '0';
          data.forEach((item: any) => {
            this.imgsList.push(item.imageUrl);
          });
        } else {
          this.currentInx = '1';
          this.imgsList.push(data[2].imageUrl);
          this.imgsList.push(data[0].imageUrl);
          this.imgsList.push(data[1].imageUrl);
        }
        this.initSwiper();
      }
    });
  }
  showimgdetail(inx: number) {
    console.log('indx:', inx);
    this.isshowimg = true;
    this.showimginx = inx;
  }
  changeshowimginx() {
    this.isshowimg = false;
    this.showimginx = -1;
  }
  initSwiper() {
    setTimeout(() => {
      var mySwiper = new Swiper('.swiper', {
        slidesPerView: 3,
        spaceBetween: 10,
        centeredSlides: true,
        loop: true,
        navigation: {
          nextEl: '.leftbtn',
          prevEl: '.rightbtn',
        },
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true,
        // },
      });
    });
  }
  onChange(inx: number) {
    this.currentInx = inx + '';
  }
  goDetail(a: any) {
    const url = a.targetUrl;
    window.location.href = url;
  }
  prevSlide() {
    (this.$refs.mySwipe as Swipe).prev();
  }
  nextSlide() {
    (this.$refs.mySwipe as Swipe).next();
  }
  prevSlide1() {
    (this.$refs.mySwipe1 as Swipe).prev();
  }
  nextSlide1() {
    (this.$refs.mySwipe1 as Swipe).next();
  }
  moredata(type: number) {
    this.$router.push(`list?inx=${type}`);
  }
}
